export const BEST_ID = "best"

export const OTHERWISE_ID = "otherwise"
